import { useParams } from "react-router-dom"
import { DatePickerCustom, InputJson, InputToken, SectionHeading, Select } from "../../components/common"
import { useEffect, useState } from "react"
import { useManagedContext, useNav } from "../../components/hooks"
import { useUsuarios } from "../../components/hooks/useUsuarios"
import { ServerRequest } from "../../utils/apiweb"
import { REQUEST_METHOD } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { onRequestError, onRequestNoSuccess, onRequestProcessError } from "../../utils/requests"
import { LISTAS } from "../../consts/listas"

const USUARIO_CACHE_KEY = 'Auditoria_UsuarioCache'

const EventoView = () => {
    const navigate = useNav()
    const params = useParams()
    const { setIsLoading } = useManagedContext()

    const [getNombreUsuario, resolveUsuarios] = useUsuarios({ key: USUARIO_CACHE_KEY })

    const [entity, setEntity] = useState({
        id: params.id,
        fecha: null,
        idModulo: 0,
        idTipoEvento: 0,
        idUsuario: 0,
        mensaje: '',
        origen: '',
        token: '',
        data: null,
    })

    const Search = (back = false, forward = false) => {
        setIsLoading(true)

        const urlParams = forward ? `/forward/${entity.id}` : back ? `/back/${entity.id}` : `/${entity.id}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EVENTO,
            urlParams,
            null,
            res => {
                res.json().then(data => {
                    data.fecha = data.fecha ? new Date(data.fecha) : null
                    setEntity(data)
                    resolveUsuarios([data.idUsuario])
                    setIsLoading(false)
                }).catch(err => {
                    onRequestProcessError(err)
                    setIsLoading(false)
                })
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    useEffect(Search, [params.id])

    const onClickBack = () => navigate({ to: Search(true, false) })
    const onClickForward = () => navigate({ to: Search(false, true) })

    const disabled = true

    return <>
        <SectionHeading
            titles={[
                { title: 'Eventos', url: '/eventos', },
                { title: `Código: ${entity.id}`, },
            ]}
        />
    
        <section className='section-accordion'>
            <div className='row form-basic'>
                <div className="col-12 col-md-4">
                    <label htmlFor="id" className="form-label">Código</label>
                    <input
                        type="number"
                        name="id"
                        className="form-control"
                        value={entity.id}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12 col-md-8">
                    <label htmlFor="token" className="form-label">Token</label>
                    <InputToken
                        name="token"
                        value={entity.token}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <label htmlFor="idTipoEvento" className="form-label">Tipo de evento</label>
                    <Select
                        name="idTipoEvento"
                        className="form-control"
                        value={entity.idTipoEvento}
                        options={LISTAS.TIPO_EVENTO.getValues().map(item => ({ value: Number(item.id), label: item.nombre }))}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <label htmlFor="idModulo" className="form-label">Módulo</label>
                    <Select
                        name="idModulo"
                        className="form-control"
                        value={entity.idModulo}
                        options={LISTAS.MODULO.getValues().map(item => ({ value: Number(item.id), label: item.nombre }))}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <label htmlFor="fecha" className="form-label">Fecha</label>
                    <DatePickerCustom
                        name="fecha"
                        className="form-control"
                        value={entity.fecha}
                        disabled={disabled}
                        time={true}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <label htmlFor="usuario" className="form-label">Usuario/a</label>
                    <input
                        type="text"
                        name="usuario"
                        className="form-control"
                        value={getNombreUsuario(entity.idUsuario)}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12 col-md-8">
                    <label htmlFor="mensaje" className="form-label">Mensaje</label>
                    <input
                        type="text"
                        name="mensaje"
                        className="form-control"
                        value={entity.mensaje}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12">
                    <label htmlFor="mensaje" className="form-label">Origen</label>
                    <input
                        type="text"
                        name="mensaje"
                        className="form-control"
                        value={entity.origen}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12">
                    <label htmlFor="data" className="form-label">Datos</label>
                    <InputJson
                        data={entity.data}
                    />
                </div>
            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <button className="btn back-button float-start" onClick={()=>window.close()}>Volver</button>
                    <button className="btn back-button m-left-5" onClick={onClickBack}>
                        <span className="material-symbols-outlined" title="Alerta Previa">chevron_left</span>
                    </button>
                    <button className="btn back-button m-left-5" onClick={onClickForward}>
                        <span className="material-symbols-outlined" title="Alerta Previa">chevron_right</span>
                    </button>
                </div>
            </footer>
        </section>
    </>
}

export default EventoView
